import React from 'react'
import PageList from '../../../components/PageListAPI'
import { getWeldingLogIdList, deleteWeldingLogIdById, getWeldingLogIdPrint } from '../../../api/welding.api'
import Button from '@mui/material/Button'
import { useDispatch } from 'react-redux'
import { fetchDispath } from '../../../functions/fetch'
import print from '../../../functions/print'
import { useCan } from 'src/hooks/useCan';
import { SLUGS } from 'src/enum/permissions.enum';
export default function WeldingLogIdList(props) {
  const can = useCan()
  return <div className='App-paper'>
    <PageList
      name='welding-log-id-list'
      title='Журнал сварочных работ'
      columns={[
        { id: 'date', name: 'Дата выполнения работ', type: 'date', formatDate: 'DD.MM.YYYY' },
        { id: 'shift', name: 'Смена', },
        { id: 'name', name: 'Наименование соединяемых элементов марка стали ', },
        { id: 'place', name: 'Место свариваемого элемента ', },
        { id: 'markDelivery', name: 'Принял узел под сварку', },
        { id: 'material', name: 'Марка применяемых сварочных материалов', },
        { id: 'atmospheric', name: 'Атмосферные условия', },
        { id: 'welders', name: 'Сварщик', },
        { id: 'responsible', name: 'Ответственный за производство работ', },
        { id: 'acceptanceMark', name: 'Отметка о приемке сварного соединения', },
        { id: 'comments', name: 'Замечания', }
      ]}
      createItem={can(SLUGS.PROJECT.WELDING.MANAGE_RECORDS)}
      deleteItem={can(SLUGS.PROJECT.WELDING.MANAGE_RECORDS)}
      loadAPI={{
        request: getWeldingLogIdList,
        querty: {
        },
        param: {
          idProject: props.match.params.idProject,
          id: props.match.params.id
        },
      }}
      tableProps={{
        pagination: false,
      }}
      click={false}
      pagination={false}
      headerLink={<HeaderLink props={props} />}
      deleteAPI={deleteWeldingLogIdById(props.match.params.idProject, props.match.params.id)}
      {...props}
    />
  </div>
}


function HeaderLink({ props }) {
  const dispatch = useDispatch()
  const handlePrint = () => {
    print(
      (obj) => dispatch(fetchDispath(obj)),
      {
        param: {
          idProject: props.match.params.idProject,
          id: props.match.params.id
        },
        request: getWeldingLogIdPrint,
      }
    )
  }
  return <Button color='primary' onClick={() => handlePrint()}>Печать</Button>
}